import { theme } from "styles/theme";

import { IInputButtonSize } from "uikit/types";

export const BUTTON_FONT_SIZE: Record<IInputButtonSize, string> = {
  small: theme.size.t14,
  medium: theme.size.t16,
  large: theme.size.t18,
};

export const BUTTON_LINE_HEIGHT: Record<IInputButtonSize, string> = {
  small: "140%",
  medium: "140%",
  large: "140%",
};

export const BUTTON_PADDING: Record<IInputButtonSize, string> = {
  small: "12px 12px",
  medium: "14px 16px",
  large: "14px 20px",
};

export const BUTTON_BORDER_RADIUS = "32px";

export const BUTTON_FIXED_WIDTH_MAX = "360px";
